import React from "react";
import { Alert } from "components/bootstrap";
import Spinner from "components/common/Spinner";
import usePluginEntities from "hooks/usePluginEntities";
const IndexMaintenanceStrategiesSummary = ({ config, pluginExports, rotationStrategyClass = void 0 }) => {
  if (!config) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const activeStrategy = config.strategy;
  const strategy = pluginExports.filter((exportedStrategy) => exportedStrategy.type === activeStrategy)[0];
  if (!(strategy == null ? void 0 : strategy.summaryComponent)) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, "Summary for strategy ", activeStrategy, " not found!");
  }
  const { summaryComponent: SummaryComponent } = strategy;
  const componentProps = rotationStrategyClass ? { config: config.config, rotationStrategyClass } : { config: config.config };
  return /* @__PURE__ */ React.createElement(SummaryComponent, { ...componentProps });
};
export const RotationStrategySummary = (props) => {
  const pluginExports = usePluginEntities("indexRotationConfig");
  return /* @__PURE__ */ React.createElement(IndexMaintenanceStrategiesSummary, { pluginExports, ...props });
};
export const RetentionStrategySummary = (props) => {
  const pluginExports = usePluginEntities("indexRetentionConfig");
  return /* @__PURE__ */ React.createElement(IndexMaintenanceStrategiesSummary, { pluginExports, ...props });
};
